import request from "@/utils/request";
// 获取区域分页树
export function getOpKnowledgeBaseCategoryTreeApi() {
  return request({
    url: "/opKnowledgeBaseCategory/knowledgeCategories",
    method: "get",
    data: {},
  });
}

// 新增
export function saveOpKnowledgeBaseCategoryApi(data) {
  return request({
    url: "/opKnowledgeBaseCategory/save",
    method: "post",
    data,
  });
}

// 修改
export function updateOpKnowledgeBaseCategoryApi(data) {
  return request({
    url: "/opKnowledgeBaseCategory/update",
    method: "post",
    data,
  });
}

// 通过id查询详情
export function getOpKnowledgeBaseCategoryApi(id) {
  return request({
    url: `/opKnowledgeBaseCategory/${id}`,
    method: "get",
  });
}

// 删除
export function deleteOpKnowledgeBaseCategoryApi(id) {
  return request({
    url: `/opKnowledgeBaseCategory/delete/${id}`,
    method: "delete",
  });
}

//拖拽树
// 修改
export function resortOpKnowledgeBaseCategoryApi(data) {
  return request({
    url: "/opKnowledgeBaseCategory/reSortTree",
    method: "post",
    data,
  });
}
